import React, { PureComponent } from 'react'
import './styles.scss'

class ErrorBoundary extends PureComponent {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch (error, info) {
    // Display fallback UI
    this.setState({ hasError: true })
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="ErrorBoundary Gradient">
          <h1>
            <i className="im im-unlink"></i>
            Oops... Something went wrong.
          </h1>
        </div>

      )
    } else {
      return this.props.children
    }

  }
}

export default ErrorBoundary
